<template>
<div class="my-auto w-100 main-area" v-if="allEvents.length > 0">
  <div class="profile-detail">
    <TitleContainer :title="'企業イベント情報'"/>
    <div
        v-for="event in allEvents"
        :key="event._id"
        class="container profile-detail-block event-block"
        :style="{
          backgroundColor: '#ffffff',
          height: event.showDetails ? 'auto' : '120px',
        }"
      >
        <div class="event-card mb-2">
          <div class="event-info p-10">
            <div class="d-flex justify-content-between">
              <p class="event-name" :class="{ 'full': event.showDetails }">{{ event.event_name }}</p>
              <div class="toggle wp-50" @click="toggleEventDetails(event._id)">
                <ArrowButton
                  :direction="event.showDetails ? 'up' : 'down'"
                  text="詳細"
                /><span class="arrow-text ml-1">詳細</span>
              </div>
            </div>
              <!-- <div class="d-flex justify-content-between align-items-end"> -->
                <div class="d-flex align-items-center justify-content-between mt-auto">
                    <p class="eventdate" v-memoize:formatEventDate="[event.event_date.from, event.event_date.to]">
                    </p>
                    <div class="ml-3">
                      <button v-if="checkApplicationStatus(event)" class="btn applied-btn">申込済</button>
                    </div>
                  <!-- <span class="ml-3 mt-2">
                    <button v-if="checkApplicationStatus(event)" class="btn applied-btn">申込済み</button>
                  </span> -->
                </div>
                
              <!-- </div> -->
          </div>
          <div v-if="event.showDetails" style="border-bottom: 1px solid #B3B3B3"></div>
          <div v-show="event.showDetails" class="event-content mt-2" style="position: relative">
              <div class="event-summary p-10">
                <p v-html="event.event_summary"></p>
              </div>
              <div style="border-bottom: 1px solid #B3B3B3"></div>
              <div class="event-details p-10">
                <p v-html="event.event_detail"></p>
              </div>
              <div class="button-container">
                  <button
                    type="button"
                    :class="checkIfApplied(event)"
                    :disabled="checkToDisable(event)"
                    @click="showEventModal(event)"
                    style="color: #ffffff; border-radius: 4px;"
                  >
                    {{ checkApplied(event) }}
                  </button>
              </div>
          </div>
        </div>
      <!-- ends profile-info-block -->
    </div>
  </div>
  <b-modal 
      id="eventModal" 
      ref="eventModal" 
      size="lg" 
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      @shown="addEventListeners"
      @hide="removeEventListeners"
    >
      <template #modal-header>
        <!-- <img
          src="../assets/close.png"
          v-on:click.prevent="cancel('event')"
          style="cursor:pointer;margin-top:5px"
        /> -->
        <h5 class="eventTitle">
          イベント申込み
        </h5>
        <!-- <button
          data-v-bf1681ae=""
          title="申込みに進む"
          class="btn btn-secondary rounded btn-sm font-16 editBtn event-edit"
          :disabled="!checkIfCompany() || eventSubmit"
          @click="openConfirmModal('event')"
        >
         申込みに進む
        </button> -->
      </template>
      <p class="event-modal-title">
        開催企業へのキャリア登録が必要です。<br />登録企業として選択してください。
      </p>
      <div
        class="d-flex px-3 py-2 flex-wrap flex-column align-items-start align-content-center"
      >
        <div class="col-md-6 p-0">
          <div
            class="col border py-1"
            v-for="(company, index) in event.companies"
            v-bind:key="company._id"
          >
            <div class="d-flex justify-content-between font-16">
              <div class="d-flex align-items-center">
                <div style="height: 20px; width: 20px;" class="mr-3">
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    :id="company._id"
                    :value="company._id"
                    name="other_companies"
                    v-model="profile.other_companies"
                  />
                </div>
                <label
                  class="form-check-label"
                  :for="company._id"
                  style="padding-top: 3px;"
                >
                  {{ company.name }}
                </label>
              </div>
              <div>
                <i
                  v-b-toggle="`accordino0_${index}`"
                  class="fa fa-chevron-down"
                  aria-hidden="true"
                  style="height: 100%"
                ></i>
              </div>
            </div>
            <div>
              <b-collapse
                class="py-1"
                v-bind:id="`accordino0_${index}`"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card>
                  <span v-html="urlify(company.short_description)"> </span>
                </b-card>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="button-container d-flex flex-column align-items-center">
            <button 
              title="申込みに進む"
              class="btn btn-secondary btn-green rounded"  
              :disabled="!checkIfCompany() || eventSubmit" 
              @click="openConfirmModal('event')" 
              >
              申込みに進む
            </button>
            <CancelModal 
              @click="cancel" 
            />
        </div>
      </template>
  </b-modal>

  <template>
    <!-- ... other template content ... -->
    <CompaniesConfirmation 
      :show="showSharingConfirm" 
      @cancel="hideConfirm" 
      @confirm="saveEvent"
    >
      <template #content>
        <p style="font-size:24px;text-align:center;font-weight:700;color:#DD3847">
          直近在籍企業など、あなたの情報を公開したくない企業が含まれていないか十分注意してください。
        </p>
        <ul class="notice-list">
          <li>
            あなたのキャリア登録情報が企業へ公開されます。
          </li>
          <li>
            企業側はあなたが他にキャリア登録している企業を知ることはできません。
          </li>
          <li>
            許諾無しにあなたがキャリア登録していない企業へ情報が公開されることはありません。
          </li>
        </ul>
      </template>
      <template #confirm-text>
        注意事項に同意してキャリア登録し<br />
        <span class="font-bold font-14" style="font-size: 18px">
          申込む
        </span>
      </template>
      <template #confirm-text-mobile>
        <span style="font-size:8px">注意事項に同意してキャリア登録し、</span><br/>
        <span style="font-weight: bold;">申込む</span>
      </template>
    </CompaniesConfirmation>
    <!-- ... other template content ... -->
  </template>
  <!-- ends profile-detail -->
</div>
</template>
<script>
import Api from "@/config/api";
// eslint-disable-next-line
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import swal from "sweetalert";
import logo from "../assets/Group300.png";
import TitleContainer from "./TitleContainer.vue";
import CompaniesConfirmation from "./CompaniesConfirmation.vue";
import modalEventListener from "../mixins/modalEventListener";
import CancelModal from "./CancelModal.vue";
import ArrowButton from "./ArrowButton.vue";

export default {
  directives: {
    memoize: {
      bind(el, binding, vnode) {
        const cache = new Map();
        const key = JSON.stringify(binding.value);
        if (!cache.has(key)) {
          cache.set(key, vnode.context[binding.arg](...binding.value));
        }
        el.textContent = cache.get(key);
      }
    }
  },
  mixins:[modalEventListener],
  name: 'Event',
  components: {
    TitleContainer,
    CompaniesConfirmation,
    CancelModal,
    ArrowButton
  },
  data() {
    return {
      events: [],
      tempEvents: [],
      tempSharingData: {},
      event: {},
      showSharingConfirm: false,
      eventSubmit: false,
      server_errors: {}
    };
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
      allEvents: 'getAllEvents',
    }),
    allEventz() {
      return [];
    },
    checkClass() {
      if (this.showSharingConfirm) {
        return 'swal-overlay swal-overlay--show-modal';
      }
      return 'swal-overlay';
    },
  },
  methods: {
    ...mapActions({
      setProfile: 'setProfile',
      setAllEvents: 'setAllEvents',
    }),
    checkIfCompany() {
      let companies = [];
      if (JSON.stringify(this.event) != "{}") {
        companies = this.event.companies.map((item) => {
          return item._id;
        });
      }
      const found = companies.some((c) =>
        this.profile.other_companies.includes(c)
      );
      return found;
    },
    toggleEventDetails(eventId) {
      // console.log(this.allEvents);
      const event = this.allEvents.find(e => e._id === eventId);
      if (event) {
        this.$set(event, 'showDetails', !event.showDetails);
      }
    },
    async saveEvent() {
      try {
        let data = {
          event_id: this.event._id,
          other_companies: this.profile.other_companies,
        };
        const token = await this.$auth.getToken();
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        this.eventSubmit = true;
        let user = await this.axios({
          method: "post",
          data,
          url: Api.url(Api.endpoints.event),
          headers: headers,
        });
        this.profile.events = user.data.data.events;
        // this.profile.other_companies = user.data.data.other_companies;
        this.$refs.eventModal.hide();
        this.showSharingConfirm = false;
        this.eventSubmit = false;
        let content = document.createElement("span");
        content.innerHTML = `<p style="font-weight:bold">イベント申込みが完了しました。</p>`;
        await new Promise((resolve) => {
        setTimeout(async () => {
            await swal({
              title: "",
              content: content,
              className: "custom-swal4",
              icon: logo,
              buttons: {
                ok: "OK",
              },
            });
            resolve();
          }, 100); // adjust the delay as needed (in milliseconds)
        });

      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.status === 403 &&
          error.response.data.data
        ) {
          swal("", error.response.data.data.error_description, "error");
        } else if (
          (error.response && error.response.status === 503) ||
          (error.response && error.response.status === 401)
        ) {
          this.$router.push({ name: "Logout" });
        } else {
          swal("", "Something Went Wrong", "error");
        }
        this.showSharingConfirm = false;
        this.$refs.eventModal.hide();
      }
      this.isEventEdit = false;
    },
    formatEventDate(eventDateFrom, eventDateTo, locale = "ja-JP") {
      // const dateFormatOptions = {
      //   month: "numeric",
      //   day: "numeric",
      //   weekday: "short",
      // };
      // const timeFormatOptions = {
      //   hour: "numeric",
      //   minute: "numeric",
      // };
        
      const formattedDateFrom = moment(eventDateFrom).locale("ja-JP").utc().format('M/D(ddd)');
      // console.log(eventDateFrom, formattedDateFrom);
      // // const formattedDateFrom1 = fromDate.toLocaleDateString(
      // //   locale,
      // //   dateFormatOptions
      // // );
      // // console.log(formattedDateFrom1);
      const formattedTimeFrom = moment(eventDateFrom)
        .utc()
        .format("HH:mm");
      const formattedTimeTo = moment(eventDateTo)
        .utc()
        .format("HH:mm");
      const displayString = `${formattedDateFrom}  ${formattedTimeFrom}~${formattedTimeTo}`;
      return displayString;
    },
    async confirmSave() {
      let res = await swal({
        title: "入力情報を更新しますか？",
        text: `更新すると、最終更新日とともに登録先企業への表示が変更されます。\n また、履歴書や職務経歴書をアップロードまたは更新した場合、登録先企業全てに同じ内容が公開されます。`,
        icon: "warning",
        className: "custom-swal",
        closeOnClickOutside: false,
        buttons: {
          cancel: "キャンセル",
          ok: {
            text: "更新する",
            value: true,
            visible: true,
            closeModal: false,
          },
        },
      });
      return res;
    },
    hideConfirm() {
      this.showSharingConfirm = false;
    },
    formatDate(date, format = 'YYYY-MM-DD') {
      // console.log(date);
      return moment(date)
        .utc()
        .format(format);
    },
    urlify(description) {
      const urlRegex = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi;
      return description.replace(urlRegex, (url) => {
        const checkLinkType =
            !!(url.includes('http') || url.includes('http'));
        if (checkLinkType) { return `<a href="${url}" target="_blank">${url}</a>`; }
        return (
          `<a href="https://${url}" target="_blank">${url}</a>`
        );
      });
    },
    redirect(link) {
      if (!link.startsWith('http://') && !link.startsWith('https://')) {
        link = `http://${link}`;
      }
      window.open(link, '_blank');
    },
    checkApplicationStatus(event) {
      if(this.profile.events.includes(event._id)) {
        return true;
      } else {
        return false;
      }
    },
    checkIfApplied(event) {
      let specificClass = '';
      if (this.profile.events.includes(event._id)) {
        specificClass = 'applied';
      } else if (
        moment(event.application_period.to)
          .utc()
          .format() < moment(new Date()).format() ||
        event.status.title == "Closed" ||
        moment(new Date()).format() <
          moment(event.application_period.from)
            .utc()
            .format()
      ) {
        specificClass = 'closed';
      } else if (event.is_test_event) {
        specificClass = 'test';
      } else {
        specificClass = 'valid';
      }
      return `event-button ${specificClass} mb-2`;
      // return false;
    },
    checkApplied(id) {
      if (this.profile.events.includes(id._id)) {
        return '申込済み';
      } else if (id.status.title === 'Closed') {
        return '受付終了';
      }
      return '申込む';
    },
    checkToDisable(event) {
      if (
        moment(event.application_period.to)
          .utc()
          .format() < moment(new Date()).format() ||
          this.profile.events.includes(event._id)
      ) {
        return true;
      } else if (
        moment(new Date()).format() <
          moment(event.application_period.from)
            .utc()
            .format()
      ) {
        return true;
      } else if (event.status.title == 'Closed') {
        return true;
      }
      return false;
    },
    showEventModal(event) {
      this.event = event;
      this.$refs.eventModal.show();
      this.tempEvents = this.profile.events;
      this.tempSharingData.other_companies = this.profile.other_companies;
    },
    cancel() {
      this.$refs.eventModal.hide();
      this.profile.other_companies = this.tempSharingData.other_companies;
      this.clearErrors();
    },
    clearErrors() {
      // clear errors
      this.errors.clear();
      this.server_errors = {};
    },
    openConfirmModal() {
      this.showSharingConfirm = true;
    },
  },
  async created() {
    await this.setProfile();
    await this.setAllEvents();
  },
};
</script>
<style>
  .event-summary,
  .event-details {
    max-height: 400px;
    overflow-y: auto;
    word-break: break-word;
  }
  .wp-50 {
    width: 50px;
  }
  .p-10 {
    padding: 10px;
  }
  .applied-btn {
    padding: 10px;
    border-radius: 4px;
    background: white;
    color: #F6AE2D;
    border: 2px solid #F6AE2D;
    cursor: default;
    font-size: 12px;
    font-weight: bold;
  }

  .button-container {
    display: flex;
    justify-content: center;
  }

  #eventModal .modal-footer {
    justify-content: center;
  }
  input[type="checkbox"] {
    background: #006c6b;
  }
  .custom-checkbox {
    width: 20px;
    height: 20px;
    color: #006c6b
  }

  .eventTitle {
    margin-top: 5px;
    color: black;
    font-weight: 800;
    margin-left: 20px;
  }

  .event-card {
    border: 0px;
    /* border-bottom: 1px solid black; */
  }

  .event-block {
    position: relative;
    padding: 0px !important;
  }

  .event-modal-title{
    margin-top: 60px;
    text-align:center;
    font-weight:600;
    font-size:18px;
  }
  .notice-list{
    font-weight:700;
    font-size: 13px;
  }

  .modal-header .close {
    padding: 0px;
    margin: 0px;
  }
  .swal-footer {
    text-align: center !important;

  }

  .custom-red-bg {
    background: #ff0000 !important;
  }
 
  .event-button {
    border-radius: 11px;
    border: #ffffff;
    width: 20%;
    height: 50px;
    font-size: 16px;
    text-align: center;
  }

  .valid {
    background: #006c6b;
    color: #ffffff !important;
  }

  .test {
    background: #219653;
    color: #ffffff !important;
  }

  .applied {
    background: #f8be57;
    color: #000000 !important;
  }

  .applied:disabled {
    opacity: 1;
    color: #000000 !important;
  }

  .test:disabled {
    opacity: 1;
  }

  .valid:disabled {
    opacity: 1;
    color: #000000 !important;
  }

  .closed {
    background: #d9d9d9;
    color: #000000 !important;
  }
  .eventdate {
    /* margin-top: 16px; */
    margin-bottom: 0;
  }
  .closed:disabled {
    opacity: 1;
    color: #000000 !important;
  }

  .event-modal-text {
    font-size: 20px;
    line-height: 38px;
  }
  .event-info {
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 1px solid #000000;
  }
  .event-name {
    /* font-family: "Yu Gothic"; */
    width: 95%;
    font-weight: 800;
    font-size: 18px;
    margin-left:8px;
    cursor: pointer;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: auto;
  }
  .event-name.full {
    -webkit-line-clamp: unset; /* Remove clamp */
    display: block;           /* Let it expand naturally */
    overflow: visible;        /* Show full text */
    white-space: normal;
  }
  .eventdate {
    font-size: 16px;
    font-weight: 400;
    /* font-family: "Yu Gothic"; */
  }

  .eventdate {
    /* border: 1px solid black; */
    padding: 2px;
    /* width: 200px; */
    text-align: center;
  }


  #eventModal > .modal-dialog > .modal-content > .modal-header {
    background: #ffffff;
  }


  #eventModal > .modal-dialog > .modal-content {
    min-height: 500px;
    max-height: 100%;
  }


  @media (max-width: 768px) {
    .event-summary,
    .event-details {
      max-height: 300px;
    }
    .applied-btn {
      font-size: 12px;
    }
    .editBtn.event-edit {
      width: 20% !important;
      font-size: 12px !important;
      white-space: normal;
    }

    .swal-footer {
      background-color: #fff !important;
    }

    .eventTitle {
      margin-left: 0px;
    }

    .event-modal-title{
      margin-top: 60px;
      text-align:center;
      font-weight:600;
      font-size:12px;
    }
    .notice-list{
      font-weight: 700;
      font-size: 10px;
      margin-left: -25px;
    }
    .swal-modal .swal-content{
      padding: 0 20px !important;
    }

    >>> .modal-lg,
    >>> .modal-xl {
      max-width: 800px !important;
    }
  }

  @media (max-width: 767px) {
    .profile-section {
      padding-left: 0;
    }

    .editBtn {
      /* width:100px !important; */
      height:40px !important;
    }

    .editBtn {
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
    .event-cancelBtn {
      padding-left: 15px !important;
      padding-right: 15px !important;
    }

  }

  .font-16 {
    font-size: 16px !important;
  }

  >>> .custom-modal-footer > button {
    min-width: 150px;
  }

  @media (min-width: 1200px) {
    >>> .modal-xl {
      max-width: 1140px !important;
    }
  }


@media (max-width: 530px) {
  .main-area {
    box-shadow: none;
  }
  .button.apply {
    width: 60px;
  }
  .event-button {
    height: 40px;
    width: 80%;
    font-size: 16px;
  }
  .btn-link {
    padding: 5px 35px !important;
  }
  .event-name {
    width: 280px;
    margin-bottom: auto;
    font-size: 16px;
    line-height: 20px;
    font-weight: 700; 
    margin-left: 0px !important;

    display: -webkit-box;
    -webkit-line-clamp: 2; /* Show 2 lines */
    -webkit-box-orient: vertical;
    white-space: normal; /* Allow text to wrap */
  }
  .eventdate {
    margin-bottom: 0;
    /* border: 1px solid black; */
    padding: 2px;
    /* width: 180px; */
    font-size: 14px;
  }
  .eventTitle {
    font-size: 18px;
    font-weight: 700;
    margin-left: 0px;
  }
}
@media (max-width: 320px) {
  .event-name {
    width: 120px;
  }
}
</style>
